// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class SetUInt8 {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetUInt8 {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetUInt8(bb: flatbuffers.ByteBuffer, obj?: SetUInt8): SetUInt8 {
    return (obj || new SetUInt8()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetUInt8(bb: flatbuffers.ByteBuffer, obj?: SetUInt8): SetUInt8 {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetUInt8()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null
  }

  static startSetUInt8(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt8(0, value, null)
  }

  static endSetUInt8(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetUInt8(builder: flatbuffers.Builder, value: number | null): flatbuffers.Offset {
    SetUInt8.startSetUInt8(builder)
    if (value !== null) SetUInt8.addValue(builder, value)
    return SetUInt8.endSetUInt8(builder)
  }
}
